<style type="text/css">
.yi_cross_select .el-loading-spinner {
  /*这个是自己想设置的 gif 加载动图*/
  background: none;
  background-image: none;
  height: 100%;
  width: auto;
  left: calc(50%-12.5px);

  background-position: center;
  /*覆盖 element-ui  默认的 50%    因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了*/
}

.yi_cross_select .el-loading-spinner .circular {
  /*隐藏 之前  element-ui  默认的 loading 动画*/
  display: block;
}

.yi_cross_select .el-loading-spinner .el-loading-text {
  /*为了让文字在loading图下面*/
  margin: 106px 0px;
  color: #da70a0;
}

.yi_cross_select .el-loading-spinner .circular {
  margin-top: 12px;
  width: 18px;
  height: 18px;
}
</style>
<template>
  <div class="yi_cross_select" style="height: 100%;display: flex;flex-direction: column;" v-loading="is_loading">
    <template v-if="isInput || isButton">
      <div>
        <el-button v-if="isButton" size="mini" :icon="icon" :disabled="disabled" :type="buttonType" plain @click.native="showDialog()">
          {{ $t(buttonTitle) }}
        </el-button>
      </div>

      <el-input v-if="!isButton" suffix-icon="el-icon-arrow-down" clearable :disabled="disabled" :placeholder="$t('qingxuanze')" v-model="showLabel" style="width: 100%;" @click.native="showDialog()" :readonly="true"> </el-input>
      <el-dialog :show-close="false" :visible.sync="is_show_dialog" width="90%" append-to-body>
        <!-- 后面加个dialog-scroller-20,40,60之类的，作为额外增加的内容高度 -->
        <div ref="yiCrossdialogScroller" class="dialog-scroller" style="display: flex;flex-direction: column;overflow: hidden;">
          <div ref="yiCrossdialogScrollerContentTop" style="width: 100%;height: 30px;display: flex;flex-flow: nowrap;flex-shrink: 0;overflow: auto;" v-if="id_bind != null && id_bind != ''">
            <div style="margin-right: 12px;margin-bottom: 10px;display: flex;flex-wrap: nowrap;" v-for="(label, index) in id_label" :key="index">
              <el-tag :type="'primary'" size="small" :closable="true" @close="deleteItem(index)">
                {{ label }}
              </el-tag>
            </div>
            <p style="flex-shrink: 0;">
              {{ $t('gong') + (id_label && id_label.length) + $t('xiang') }}
            </p>

          </div>
          <div ref="yiCrossdialogScrollerContentBottom" class="dialog-scroller-content" style="width: 100%;" :style="{ height: dialogBottomHeight }">
            <component v-bind="$attrs" :max="max" style="height: 100%;width: 100%;;" ref="childs2" v-bind:is="component" :fixConditions="fixConditions" :fixShowColumns="fixShowColumns" :ids="id_bind" :isShowButtons="isShowButtons" :isShowCaoZuo="isShowCaoZuo" @getItemsByIds="getItemsByIds" @getItem="getItem" @deleteItem="deleteItem"> </component>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="
            cancel();
          is_show_dialog = false;
          ">
            {{ $t('quxiao') }}
          </el-button>
          <el-button size="mini" @click="save()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </el-dialog>
    </template>
    <template v-else>
      <div style="width: 100%;display: flex;flex-flow: wrap;flex-shrink: 0;" v-if="id_bind != null && id_bind != ''">
        <div style="margin-right: 12px;margin-bottom: 10px" v-for="(label, index) in id_label" :key="index">
          <el-tag :type="'primary'" size="small" :closable="true" @close="deleteItem(index)">
            {{ label }}
          </el-tag>
        </div>
        <span>{{ $t('gong') }}</span>&nbsp; <span style="color: #419fff;">{{ id_label.length }}</span>&nbsp;
        <span>{{ $t('xiang') }}</span>
      </div>
      <div v-else style="height: 34px;color: #999999;">
        {{ $t('qingxuanze') }}
      </div>
      <div style="flex: 1;">
        <component v-bind="$attrs" :max="max" ref="childs2" v-bind:is="component" :fixConditions="fixConditions" :fixShowColumns="fixShowColumns" :ids="id_bind" :isShowButtons="isShowButtons" :isShowCaoZuo="isShowCaoZuo" @getItemsByIds="getItemsByIds" @getItem="getItem" @deleteItem="deleteItem"> </component>
      </div>
    </template>

    <component v-bind="$attrs" :max="max" v-show="false" ref="childs" v-bind:is="component" :ids="id_bind" @getItemsByIds="getItemsByIds" :isOnlyShowBack="true"> </component>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'yi_cross_select',
  props: {
    component: {
      type: String,
      default: null
    },
    ids: {},
    //这个用来做初始化的，一旦传了这个objs，就会用这个来初始化，而不是用ids
    objs: {
      type: Array,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 999
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //是否输入框模式
    isInput: {
      type: Boolean,
      default: true
    },
    isButton: {
      type: Boolean,
      default: false
    },
    buttonType: {
      type: String,
      default: 'default'
    },
    buttonTitle: {
      type: String,
      default: 'tianjia'
    },
    //是否显示按钮栏
    isShowButtons: {
      type: Boolean,
      default: false
    },
    //是否显示操作栏
    isShowCaoZuo: {
      type: Boolean,
      default: false
    },
    selectTitle: {
      type: String,
      default: null
    },
    //外部传入固定的组件高度
    fixShowColumns: {
      type: Array,
      default: function () {
        return [];
      }
    },
    //外部传入固定的组件高度
    beforeSave: {
      type: Function,
      default: null
    },

    fixConditions: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
      showLabel: '',
      origin_id_bind: null,
      origin_id_label: [],
      origin_id_item: null,
      id_bind: this.ids,
      id_label: [],
      id_item: null,
      is_show_dialog: false,
      is_loading: true,
      dialogBottomHeight: '100%'
      //请求getItems的时候进行loading，不返回不接触loading
    };
  },
  created() {
    // 需要从爷爷组件直接传给子组件的数据，不要在父组件中的props中声明。

    // 在子组件上通过v-bind的方式就可以把父组件中未声明而子组件需要从爷爷组件中获取的数据传给子组件。

    // 当然，子组件props肯定是要声明的，还是props的用法啦。
    //ids是attrs传过来的

    if (this.multiple) {
      if (this.ids == null || this.ids == '') {
        this.id_bind = [];
      } else {
        this.id_bind = this.ids;
      }
    } else {
      if (this.ids == null || this.ids == '') {
        this.id_bind = [];
      } else {
        this.id_bind = [this.ids];
      }
    }

    this.childsGetItemsByIds();

    this.setSelectTitle();
  },
  mounted() { },
  watch: {
    origin_id_label(n, o) {
      this.showLabel = this.origin_id_label.join(',');
    },
    ids(n, o) {
      if (n == undefined || n == null) {
        this.id_bind = [];
        this.id_label = [];
        this.origin_id_bind = [];
        this.origin_id_label = [];
        this.origin_id_item = [];
        this.id_item = [];
      }
    }
  },

  methods: {
    //强改
    setIds(ids) {
      //因为强制save会造成死循环，所以一样就不改了
      // 使用JSON.stringify深度比较判断数组是否相等，避免空数组时引用比较失败
      if (JSON.stringify(ids) === JSON.stringify(this.id_bind)) {
        return;
      }

      if (this.multiple) {
        if (ids == null || ids == '') {
          this.id_bind = [];
        } else {
          this.id_bind = ids;
        }
      } else {
        if (ids == null || ids == '') {
          this.id_bind = [];
        } else {
          this.id_bind = [ids];
        }
      }

      this.$nextTick(() => {
        this.$refs.childs.yt.getItemsByIds();
        //因为是强行修改，所以不会有取消操作了，所以必须save
        this.setIdSave();
      });
      // this.setSelectTitle()
    },
    setSelectTitle() {
      if (this.$refs.childs2 == null) {
        setTimeout(() => {
          this.setSelectTitle();
        }, 30);
        return;
      }
      //等待子组件的yt加载完成
      if (this.$refs.childs2.yt.SELECT_URL == null || this.$refs.childs2.yt.SELECT_URL == '') {
        setTimeout(() => {
          this.setSelectTitle();
        }, 30);
        return;
      }
      if (this.selectTitle) {
        this.$refs.childs2.yt.SELECT_TITLE = this.selectTitle;
      }
    },
    childsGetItemsByIds() {
      //等待子组件加载完成
      if (this.$refs.childs == null) {
        setTimeout(() => {
          this.childsGetItemsByIds();
        }, 30);
        return;
      }
      //等待子组件的yt加载完成
      if (this.$refs.childs.yt.SELECT_URL == null || this.$refs.childs.yt.SELECT_URL == '') {
        setTimeout(() => {
          this.childsGetItemsByIds();
        }, 30);
        return;
      }
      if (this.$refs.childs.yt.getItemsByIds == null) {
        setTimeout(() => {
          this.childsGetItemsByIds();
        }, 30);
        return;
      }
      if (this.selectTitle) {
        this.$refs.childs.yt.SELECT_TITLE = this.selectTitle;
      }

      if (this.objs != null) {
        this.initByObjs();
      } else {
        this.$refs.childs.yt.getItemsByIds();
      }
    },
    showDialog(force = false) {
      //外部强行打开
      if (force) {
        this.is_show_dialog = true;
        this.calculateDialogHeight();
        return;
      }

      if (this.disabled == true) {
        return;
      }
      if (this.is_loading == true) {
        return;
      }

      this.is_show_dialog = true;
      this.calculateDialogHeight();
    },
    deleteItem(index) {
      this.id_bind.splice(index, 1);
      this.id_label.splice(index, 1);
      this.id_item.splice(index, 1);
      if (!this.isInput) {
        this.save();
      }
    },
    initByObjs() {
      this.is_loading = false;

      var items = this.utils.copy(this.objs);
      var ids = [];
      var labels = [];

      for (var i = 0; i < items.length; i++) {
        ids.push(items[i][this.$refs.childs.yt.SELECT_ID]);

        //迟点估计还要支持对象的嵌套层级
        let title = '';
        for (var j = 0; j < this.$refs.childs.yt.SELECT_TITLE.split(',').length; j++) {
          let select_titles = this.$refs.childs.yt.SELECT_TITLE.split(',')[j];
          if (j == 0) {
            title += this.utils.getObjValueByLevelString(items[i], select_titles);
          } else {
            title += ' | ' + this.utils.getObjValueByLevelString(items[i], select_titles);
          }
        }

        labels.push(title);
      }

      this.id_bind = ids;
      this.id_label = labels;
      this.id_item = items;
      this.origin_id_label = this.utils.copy(this.id_label);
      this.origin_id_bind = this.utils.copy(this.id_bind);
      this.origin_id_item = this.utils.copy(this.id_item);
      if (!this.isInput) {
        this.save();
      }
    },
    getItemsByIds(items, id_bind, id_label) {
      this.is_loading = false;
      this.id_bind = id_bind;
      this.id_label = id_label;
      this.id_item = items;
      this.origin_id_label = this.utils.copy(this.id_label);
      this.origin_id_bind = this.utils.copy(this.id_bind);
      this.origin_id_item = this.utils.copy(this.id_item);
      if (!this.isInput) {
        this.save();
      } else {
        if (this.multiple) {
          this.$emit('update:ids', this.id_bind);
          this.$emit('getItems', this.id_item);
        } else {
          if (this.id_bind.length > 0) {
            this.$emit('update:ids', this.id_bind[0]);
            this.$emit('getItems', this.id_item[0]);
          } else {
            this.$emit('update:ids', null);
            this.$emit('getItems', null);
          }
        }
      }
    },
    getItem(item, id, label) {
      console.log(id);

      if (this.max == 1) {
        //如果是单选就直接替换
        this.id_bind = [];
        this.id_label = [];
        this.id_item = [];
      } else {
        if (this.id_bind.length >= this.max) {
          this.utils.errorMessage(this.$t('chaoguozuidakexuanshuliang'));
          return;
        }

        if (this.id_bind.includes(id)) {
          return;
        }
      }

      this.id_bind.push(id);
      this.id_label.push(label);
      this.id_item.push(item);

      if (!this.isInput) {
        this.save();
      }
    },

    cancel() {
      this.id_label = this.utils.copy(this.origin_id_label);
      this.id_bind = this.utils.copy(this.origin_id_bind);
      this.id_item = this.utils.copy(this.origin_id_item);
      this.$emit('cancel');
    },
    async save() {
      if (this.beforeSave != null) {
        let result = await this.beforeSave(this.id_bind, this.id_item);
        if (result == false) {
          return;
        }
      }
      if (this.multiple) {
        this.$emit('update:ids', this.id_bind);
        this.$emit('getItems', this.id_item);
      } else {
        if (this.id_bind.length > 0) {
          this.$emit('update:ids', this.id_bind[0]);
          this.$emit('getItems', this.id_item[0]);
        } else {
          this.$emit('update:ids', null);
          this.$emit('getItems', null);
        }
      }
      this.origin_id_label = this.utils.copy(this.id_label);
      this.origin_id_bind = this.utils.copy(this.id_bind);
      this.origin_id_item = this.utils.copy(this.id_item);

      this.is_show_dialog = false;
    },
    calculateDialogHeight() {
      setTimeout(() => {
        if (this.$refs.yiCrossdialogScroller && this.$refs.yiCrossdialogScrollerContentTop) {
          const scrollerHeight = this.$refs.yiCrossdialogScroller.offsetHeight;
          const topHeight = this.$refs.yiCrossdialogScrollerContentTop.offsetHeight;
          const bottomHeight = scrollerHeight - topHeight - 20; // 减去一些边距
          this.dialogBottomHeight = Math.max(bottomHeight, 200) + 'px'; // 最小高度200px
        }
      }, 100);
    },
    //静默setId用下面的save，不触发getItems，防止死循环
    setIdSave() {
      if (this.multiple) {
        this.$emit('update:ids', this.id_bind);
      } else {
        if (this.id_bind.length > 0) {
          this.$emit('update:ids', this.id_bind[0]);
        } else {
          this.$emit('update:ids', null);
        }
      }
      this.origin_id_label = this.utils.copy(this.id_label);
      this.origin_id_bind = this.utils.copy(this.id_bind);
      this.origin_id_item = this.utils.copy(this.id_item);
    }
  }
};
</script>